export const resultListTitles = [
  {
    titleName: "id",
    colWidth: "30px",
  },
  { titleName: "Result label", colWidth: "150px", key: "label" },
  { titleName: "Branch", colWidth: "100px", key: "schoolBranchName" },
  { titleName: "Class", colWidth: "100px", key: "className" },
  { titleName: "Publish date", colWidth: "200px", key: "publishDate" },
];
